
<app-user-header></app-user-header>

<div class="container-fluid container-m-t">
    <div class="row">
        <div class="col-sm-3 left-panel-mobile-view">
                <div class="row h-105">
                        <!-- left sidebar -->
                        <div class="col-md-10 fixed pl-0 py-2 left left-sidebar ">
                            <ul class="nav flex-md-column flex-nowrap justify-content-center m-l-ipad">
                                <li class="img-circle-styles" style="text-align: center; margin-top: 34px;"><img style="    border: 1px solid #FFF;border-radius: 49%;width: 40%;height: 40%;"
                                        src="assets/images/user-image.png" class="img-circle" alt="Cinque Terre">
                                    <h5 class="center user-text" style="text-align:  center;">
                                        {{ramki.firstName + "  "+ ramki.lastName}} </h5>
                                </li>
                
                                <!-- <li>
                
                                    <a class="nav-link">
                                           <span> Tax Year        </span>           
                                            
                                                <select style="text-align-last:center;" class="form-control select-lag" name="userYear" id="userYear"
                                                    onchange="yearChange()">                                       
                                                    <option value="<?php echo $i;?>"></option>                   
                                                </select>
                                            
                                    </a>
                                    
                                </li> -->
                
                                          
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Dashboard">
                                    <a class="nav-link font-size-ipad" routerLink="/dashboard">
                                        <img src="assets/images/dashboard.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Dashboard</span>
                                    </a>
                                </li><br>
                
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Basic Information">
                                    <a class="nav-link font-size-ipad"  routerLink="/basic">
                                        <img src="assets/images/information.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Basic Information</span>
                                    </a>
                                </li><br>
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="My Documents">
                                    <a class="nav-link font-size-ipad" routerLink="/documents">
                                        <img src="assets/images/doc.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">My Documents</span>
                                    </a>
                                </li><br>
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Download Tax Return">
                                    <a class="nav-link font-size-ipad" routerLink="/download">
                                        <img src="assets/images/tax.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Download Tax Return</span>
                                    </a>
                                </li><br>
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Make Payment">
                                    <a class="nav-link font-size-ipad" routerLink="/payment">
                                        <img src="assets/images/payment.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text">Make A Payment</span>
                                    </a>
                                </li><br>
                                <li class="nav-item" data-toggle="tooltip" data-placement="right" title="Consent Of Disclosure" style="background: black;">
                                    <a class="nav-link font-size-ipad" routerLink="/disclosure">
                                        <img src="assets/images/disclosure.svg" style="width: auto; height: auto;">&nbsp;
                                        <span class="nav-link-text sidebar-text" style="color: white;">Consent Of Disclosure</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                
                </div>
        </div>
        <!-- <div class="col-sm-1"></div> -->
        <div class="col-sm-9 col-m-t">
            <div class="dash-row">Consent Of Disclosure</div>
            <br>
            <div>
                <p style="text-align: justify;">
                    Federal law requires this consent form be provided to you. Unless authorized by law, we cannot disclose, without
                    your consent, your tax return information to third parties for purposes other than the preparation and filing of
                    your tax return. If you consent to the disclosure of your tax return information, Federal law may not protect your
                    tax return information from further use or distribution.
                
                    You are not required to complete this form. If we obtain your signature on this form by conditioning our service on
                    your consent, your consent will not be valid. If you agree to the disclosure of your tax return information, your
                    consent is valid for the amount of time that you specify. If you do not specify the duration of your consent, your
                    consent is valid for one year.
                
                    Warning: Once your tax return information has been disclosed to a third party per your consent, we have no control
                    over what the third party does with your tax return information. If the third party uses or discloses your tax
                    return information for purposes other than the purpose for which you authorized the disclosure, we are not
                    responsible for that unauthorized disclosure, and federal tax law may not protect that unauthorized disclosure.
                
                    I authorize, Universal Technologies Solutions Inc., to disclose my information. Disclosure of the tax return
                    information described above has been specifically requested by me.
                </p>
            </div>
                <div class="footer" style="text-align: center;background-color: #e9ecef;
                line-height: 55px; color: black;">
                        Copyright ©2020 Evolvtax Services Pvt Ltd. All rights reserved
                </div>
        </div>
    </div>
</div>
